<h5 class="text-primary-text">Change Password</h5>

<div class="p-16 border-1 border-solid rounded-lg">
  <ng-container *ngIf="componentState === ComponentStateEnum.DEFAULT">
    <ng-container *ngIf="forceChange">
      <p class="text-error">Your password has expired and needs to be changed.</p>
    </ng-container>
    <p class="text-sm">
      Use this form to change your current password.<br />
      Make sure to remember your password or store it at a secure location.
    </p>

    <form nz-form [formGroup]="passwordChangeForm">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="tempPasswordErrorTpl">
          <nz-input-group [nzAddOnBefore]="tempPasswordIconTpl">
            <input
              nz-input
              nzSize="large"
              aria-label="Current password"
              data-test="current-password-input"
              formControlName="currentPassword"
              placeholder="Current password"
              type="password"
            />
            <ng-template #tempPasswordErrorTpl let-control>
              <div class="text-left" *ngIf="control.hasError('required')">Your current password is required!</div>
            </ng-template>
            <ng-template #tempPasswordIconTpl>
              <twaice-fe-svg-icon name="key" size="13px" source="tabler" />
            </ng-template>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <twaice-fe-new-password (formGroupGenerated)="onFormGroupGenerated($event)" inputAppearance="fill"></twaice-fe-new-password>
      <p *ngIf="error" class="text-danger" data-test="server-side-error">ERROR: {{ error }}</p>
      <div class="flex justify-end">
        <button nz-button nzType="primary" (click)="setNewPassword()" data-test="submit-form-button">Change Password</button>
      </div>
    </form>
  </ng-container>
  <twaice-fe-progress-spinner
    *ngIf="componentState === ComponentStateEnum.PASSWORD_CHANGE_IN_PROGRESS"
    spinnerText="Changing password in progress..."
  ></twaice-fe-progress-spinner>
  <p *ngIf="componentState === ComponentStateEnum.PASSWORD_CHANGE_COMPLETE" data-test="success-text">
    Your password was successfully changed!
  </p>
</div>
